module.exports = __webpack_public_path__ + "img/0x37f3ef4e065f3415d1b6f9284389cc9d9439f658.bce5b67e.png";